/**
 * Zustand store for managing unit selection state.
 */

import { create } from 'zustand';

interface UnitSelectionState {
  selectedUnitIds: string[];
  setSelectedUnits: (unitIds: string[]) => void;
  clearSelection: () => void;
  getSelectedUnits: () => string[];
}

export const useUnitSelectionStore = create<UnitSelectionState>((set, get) => ({
  selectedUnitIds: [],
  setSelectedUnits: (unitIds: string[]) =>
    set({ selectedUnitIds: [...unitIds] }),
  clearSelection: () => set({ selectedUnitIds: [] }),
  getSelectedUnits: () => get().selectedUnitIds,
}));

